import ModalPasswordChangeConfirmationController from './modal/modal-password-change-confirmation.controller';
import templateModalPasswordChangeConfirmation from './modal/modal-password-change-confirmation.html';

/* globals Knitiv */

export default class PassChangeController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor(
		$location,
		$rootScope,
		$routeParams,
		$translate,
		$uibModal,
	) {
		this.uid = $routeParams.uid;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$translate = $translate;
		this.$uibModal = $uibModal;

		this.passwordSubmitButton = this.$translate.instant('user.passchange-submit');
		this.$rootScope.title = 'account.change-pass';
	}

	async confirmPasswordChange() {
		await this.$uibModal.open({
			backdrop:     'static',
			controller:   ModalPasswordChangeConfirmationController,
			controllerAs: '$ctrl',
			template:     templateModalPasswordChangeConfirmation,
		}).result;
		if (this.$rootScope.context?.profil?.kid) {
			this.$rootScope.$emit('User.login');
		}
		this.$location.url('/');
	}
}
